import { COLORS } from '@avalara/bat-apps-shared/constants';
import { SBox } from '@avalara/skylab-sdk/react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import type { QuestionOption, QuestionnaireInputType } from '../../../../../types/prequal-questionnaire';
import { selectAnswer } from '../../../store/prequal-questionnaire';
import ConnectorSearch from './connector-search';

const FakeLabel = styled.label`
  margin-top: -1rem !important;
`;

const QuestionWrapper = styled.div<{ selected: boolean }>`
cursor: pointer;
${({ selected }) =>
  selected &&
  `
  s-box {
    border: 1px ${COLORS.blue} solid;
  }
`}`;

type QuestionSelectProps = {
  questionId: string;
  options: Array<QuestionOption>;
  questionType: QuestionnaireInputType;
  questionSelectedAnswers: Array<string>;
  groupName: string;
};
// 40,47-66
const QuestionSelect = ({
  questionId,
  options,
  questionType,
  questionSelectedAnswers,
  groupName,
}: QuestionSelectProps) => {
  const dispatch = useDispatch();
  const onSelect = (answer: string) => {
    dispatch(selectAnswer({ questionId, questionType, answer }));
  };

  return (
    <fieldset>
      {options.map((option, index) => (
        <QuestionWrapper
          data-ref='buy.prequal.question-select.select-wrapper'
          onClick={() => onSelect(option.value)}
          className='padding-bottom-sm margin-bottom-sm'
          selected={questionSelectedAnswers.includes(option.value)}
          key={option.value}
        >
          <SBox className={questionSelectedAnswers.includes(option.value) ? 'secondary' : ''}>
            <div className='flex align-items-center'>
              <input
                data-ref={`buy.prequal.question-select.${groupName}-${index}-input`}
                type={questionType}
                id={`${groupName}${index}Input`}
                aria-labelledby={`${groupName}${index}Label`}
                value={option.value}
                checked={questionSelectedAnswers.includes(option.value)}
                onChange={() => {}}
                name={groupName}
              />

              {/* Fake label to get skylab input to render */}
              <FakeLabel
                data-ref='buy.prequal.fake-label'
                onClick={(e) => e.stopPropagation()}
                htmlFor={`${groupName}${index}Input`}
              />

              {!!option.imageFile && (
                <img
                  data-ref='buy.prequal.question-select.image'
                  src={option.imageFile}
                  alt=''
                  height={60}
                  className='margin-left-md margin-right-md'
                />
              )}

              <span id={`${groupName}${index}Label`} className='margin-all-sm font-semibold'>
                {option.value}
              </span>
            </div>

            {!!option.description && (
              <p data-ref='buy.prequal.question-select.option-description'>{option.description}</p>
            )}
            {option.showConnectorSearch && (
              <ConnectorSearch
                onSelect={onSelect}
                disabled={!questionSelectedAnswers.includes(option.value)}
                questionSelectedAnswers={questionSelectedAnswers}
                questionId={questionId}
              />
            )}
          </SBox>
        </QuestionWrapper>
      ))}
    </fieldset>
  );
};

export default QuestionSelect;
